import httpApi from "@/apis/httpApi";
import http from "@/utils/http.js";

// 获取上架交易行的游戏列表
interface ChargeGameListData {
  token: string;
}

export const chargeGameList = (json: ChargeGameListData): any =>
  http.httpPost({
    url: httpApi.gameManage.chargeGameList,
    json,
  });

// 试玩开关
interface ShiwanStatusData {
  token: string;
  box_game_id: string;
  type: number;
}

export const shiwanStatus = (json: ShiwanStatusData): any =>
  http.httpPost({
    url: httpApi.gameManage.shiwanStatus,
    json,
  });

// 上架交易行的游戏列表,停用、启用、删除操作
interface ChargeStatusData {
  box_game_id: string;
  type: string;
}

export const chargeStatus = (json: ChargeStatusData): any =>
  http.httpPost({
    url: httpApi.gameManage.chargeStatus,
    json,
  });

// 获取游戏列表
interface GameListData {
  token: string;
}

export const gameList = (json: GameListData): any =>
  http.httpPost({
    url: httpApi.gameManage.gameList,
    json,
  });

// 游戏管理---添加游戏
interface CreateGameData {
  box_game_id: string;
  coin_config: any;
  role_min_price: string;
  inspect_days: string;
  commodity_expire_hour: string;
  service_percent: string;
  gm_service_percent: string;
  official_service_percent: string;
  user_max_buy_count: string;
  game_variable: string;
  // jyh_box_status: number;
  role_shelf_min_level: number;
  role_shelf_min_recharge: number;
}

export const createGame = (json: CreateGameData): any =>
  http.httpPost({
    url: httpApi.gameManage.createGame,
    json,
  });

// 游戏管理---编辑游戏
export const editGame = (json: CreateGameData): any =>
  http.httpPost({
    url: httpApi.gameManage.editGame,
    json,
  });

// 游戏管理---游戏详情
interface GameInfoData {
  box_game_id: string;
}

export const gameInfo = (json: GameInfoData): any =>
  http.httpPost({
    url: httpApi.gameManage.gameInfo,
    json,
  });

// 游戏管理---游戏详情--货币配置删除
interface DelCoinData {
  box_game_id: string;
  id: string;
}

export const delCoin = (json: DelCoinData): any =>
  http.httpPost({
    url: httpApi.gameManage.delCoin,
    json,
  });

// 游戏管理---游戏详情--编辑货币配置
interface EditGameCoinData {
  box_game_id: string;
  coin_config: any;
}

export const editGameCoin = (json: EditGameCoinData): any =>
  http.httpPost({
    url: httpApi.gameManage.editGameCoin,
    json,
  });

// 游戏管理---游戏详情--编辑变量配置
interface EditGameVariableData {
  box_game_id: string;
  game_variable: any;
}

export const editGameVariable = (json: EditGameVariableData): any =>
  http.httpPost({
    url: httpApi.gameManage.editGameVariable,
    json,
  });

// 订单管理---订单列表
interface OrderListData {
  order_num: string;
  commodity_title: string;
  purchaser_username: string;
  seller_username: string;
  game_id: string;
  create_time: string;
  status: string;
  seller_uid: string;
  purchaser_uid: string;
  page: number;
  limit: number;
}

export const orderList = (json: OrderListData): any =>
  http.httpPost({
    url: httpApi.gameManage.orderList,
    json,
  });

// 订单管理---订单详情
interface OrderDetailData {
  order_id: string;
}

export const orderDetail = (json: OrderDetailData): any =>
  http.httpPost({
    url: httpApi.gameManage.orderDetail,
    json,
  });

// 订单管理---导出表格
interface OrderExcelData {
  order_num: string;
  commodity_title: string;
  purchaser_username: string;
  seller_username: string;
  game_id: string;
  create_time: string;
}

export const orderExcel = (json: OrderExcelData): any =>
  http.httpGet({
    url: httpApi.gameManage.orderExcel,
    json,
  });

// 订单管理---退款
interface BackMoneyData {
  id: string;
}

export const backMoney = (json: BackMoneyData): any =>
  http.httpPost({
    url: httpApi.gameManage.backMoney,
    json,
  });
// 订单管理---退角色
interface BackRoleData {
  id: string;
}

export const backRole = (json: BackRoleData): any =>
  http.httpPost({
    url: httpApi.gameManage.backRole,
    json,
  });
// 订单管理---再次发货
interface RedeliveryeData {
  order_id: string | number;
}

export const redelivery = (json: RedeliveryeData): any =>
  http.httpPost({
    url: httpApi.gameManage.redelivery,
    json,
  });

// 帮助中心编辑
interface HelpCentersData {
  data: string;
  type: string;
}

export const helpCenters = (json: HelpCentersData): any =>
  http.httpPost({
    url: httpApi.gameManage.helpCenters,
    json,
  });

export const getServerList = (urls: string) =>
  http.httpGet({
    url: urls,
  });

// 修改订单
interface EditStatusData {
  token: string;
  order_id: string;
  status: string;
}

export const editStatus = (json: EditStatusData) =>
  http.httpPost({
    url: httpApi.gameManage.editStatus,
    json,
  });

// 游戏模板配置
export const apiNameListConfig = (): any =>
  http.httpPost({
    url: httpApi.gameManage.nameListConfig,
  });

interface PayItemIdCheckData {
  token: string;
  coin_type_ids: string;
  game_id: string;
}


// 可充值货币校验接口
export const payItemIdCheck = (json: PayItemIdCheckData): any =>
  http.httpPost({
    url: httpApi.gameManage.payItemIdCheck,
    json
  });
